<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)"
                srcset="assets/img/school-desktop-banners/arni-school-of-business-management-and-commerce.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-business-management-and-commerce.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-business-management-and-commerce.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>
<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Courses</a>
            <a href="#specialization"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Specialization</a>
            <a href="#hod-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">HOD's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Expert
                Faculty</a>
           <!-- <a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Business Management & Commerce</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">
                The ARNI School of Business Management & Commerce is the place for potential leaders to become business
                professionals. We strive to develop future-ready leaders, innovators, and successful business people
                ready to thrive in a globally competitive economy. Our courses are perfect for students who want to
                develop a career in business and finance management.
            </p>
            <p class="text-gray-500 text-justify mt-2">Developing future leaders, entrepreneurs, and professionals is
                about more than shaping the future of business; it is about making a meaningful contribution toward the
                economic, social, and environmental betterment of society.
            </p>
            <p class="text-gray-500 text-justify mt-2">We are proud to deliver a vibrant learning space that combines
                the academic quest for excellence and the real-world opportunities and challenges facing businesses
                today. Our courses are focused on the development of skills in entrepreneurship, strategic thinking,
                finance, marketing, and other emerging areas of business. Whether you aspire to work for a global
                corporation, own your own business, or become a finance expert, ARNI's courses help you build the
                foundations necessary and extend your industry-relevant skills.</p>
            <p class="text-gray-500 text-justify mt-2">Committed to academic excellence, industry-standard teaching
                practices, and experience-focused learning – the School of Business Management & Commerce at ARNI
                University provides you with a pathway to a successful career in the business world.</p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision:</strong>Through our continued efforts and
                dedication to craft the leaders for the business world, our vision is to be recognized leading
                educational institute for business and finance education that inspires students to think creatively, act
                ethically, and lead responsibly.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission:</strong>
                Our mission is to provide a transformational education that blends academic rigor with practical
                experience, ensuring that our students are well-prepared to face the challenges of the business world
                with our dynamic programs, experienced faculty, and industry partnerships.
            </p>
        </div>
        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">At ARNI School of Business Management & Commerce provides a pathway
                for students through a range of undergraduate and postgraduate programs, diplomas, and doctoral
                programs. It allows students to develop "real-world" experience through internships, networking events,
                and experiential learning projects.
            </p>
            <p class="text-gray-500 text-justify">All our courses are designed to cater to the requirements of a
                constantly changing business world, providing students with foundational knowledge and specialized
                skills. They will develop critical thinking, problem-solving, leadership skills, communication, and a
                global outlook to become confident and competent in solving issues.
            </p>
            <p class="text-gray-500 text-justify">Most importantly, we are committed to developing an entrepreneurial
                mindset in our students, and
                contributing to the development of criminals, and to developing a new generation of professionals that
                are "future-ready".
            </p>
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> Students pursuing commerce or business
                management courses have diverse opportunities in accounting, finance, marketing, human resources,
                banking, entrepreneurship, and consulting, with roles in corporate, government, non-profit, and
                entrepreneurial ventures.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Fields such as accounting, finance, marketing, HR, banking,
                    consulting, and entrepreneurship are all possible, and involve corporate, government, NGO's, and
                    start-ups.
                </li>
                <li class="text-gray-500 text-justify my-2">Professional and managerial opportunities, in MNCs,
                    start-ups, and SME's that require a leader of a team or manager of an organization.
                </li>
                <li class="text-gray-500 text-justify my-2">We develop opportunities in corporate finance, investment
                    banking, financial planning and FinTech, combined with finance, to provide you with a sound
                    understanding of markets and an understanding of using analytics for decision making.
                </li>
                <li class="text-gray-500 text-justify my-2">It is also important to acknowledge that globalization
                    represents an opportunity to work in export-import management, global supply chains, and global
                    finance.
                </li>
                <li class="text-gray-500 text-justify my-2">We develop your ability to analyze using business
                    intelligence tools and analytics, so you can understand how to interpret and present data to inform
                    decision-making.
                </li>
                <li class="text-gray-500 text-justify my-2">For those interested in an academic career, advanced study
                    and research, and transition to becoming lecturers, consultants, or academics in management studies.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">Join us on this exciting journey, and together, let's build a
                brighter, more sustainable future for the business world.</p>
        </div>
        <h2 class="text-xl font-bold">Career Opportunities</h2>
        <ul class="list-disc mb-4 px-5">
            <li class="text-gray-500  my-2"><span class="font-semibold">Business Analyst -</span> Analyze trends, create
                business solutions, and optimize processes for improved profitability.
            </li>
            <li class="text-gray-500  my-2"><span class="font-semibold">Marketing Executive / Digital Marketing Manager -</span>
                Create brand strategies, manage digital campaigns, and drive customer engagement for products and
                services.
            </li>
            <li class="text-gray-500  my-2"><span class="font-semibold">Financial Advisor / Investment Banker -</span>
                Guide businesses or individuals in financial planning, investments, and wealth management.
            </li>
            <li class="text-gray-500  my-2"><span
                class="font-semibold">HR Manager / Talent Acquisition Specialist -</span> Handle recruitment, employee
                development, and policy formulation to enhance workforce productivity.
            </li>
            <li class="text-gray-500  my-2"><span class="font-semibold">Operations & Supply Chain Manager -</span>
                Ensure smooth logistics, procurement, and supply chain activities in manufacturing or retail sectors.
            </li>
        </ul>
        <h2 class="text-xl font-bold mb-2">ARNI University’s Contribution</h2>
        <p class="my-2 text-gray-500">ARNI University goes beyond traditional education—it is a hub for
            business innovation and entrepreneurial
            excellence. We inspire students to challenge conventional thinking and implement modern, tech-enabled
            solutions.</p>
        <p class="my-2 text-gray-500">Through our strong industry collaborations, we offer placements,
            internships, and mentorship programs. Our teaching methodology blends classroom theory with practical
            exposure, ensuring students are well-equipped for real-world challenges.
        </p>
        <p class="my-2 text-gray-500">From industrial visits, live projects, and simulation labs to guest
            lectures by industry leaders, we provide a comprehensive learning experience. Facilities such as a business
            simulation lab, digital library, and case-based learning tools further enrich student learning.</p>
        <p class="my-2 text-gray-500">At ARNI University, we are committed to nurturing ethical,
            innovative, and globally competent business leaders who can positively impact society and the economy.
        </p>
        <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
        <ul class="list-disc px-5">
            <li class="text-gray-500 my-2">We offer industry-aligned curricula that are updated regularly with
                real-world relevance, covering ongoing business practices, market dynamics, and emerging technologies.
            </li>
            <li class="text-gray-500 my-2">We possess a team of academic scholars and mentors who are passionate about
                providing business management and commerce with years of practical exposure and research experience.
            </li>
            <li class="text-gray-500 my-2">We are not just providing a degree, we are committed to placing our valuable
                students in their respective fields. We have a team of dedicated professionals to offer excellent
                placement assistance through industry tie-ups, career counseling, and skill enhancement workshops.
            </li>
            <li class="text-gray-500 my-2">We blend theoretical learning with practical exposure using case studies to
                simulation labs, and live projects, and students get multiple opportunities to learn by doing.
            </li>
            <li class="text-gray-500 my-2">The university is building partnerships with international institutions and
                organizations for global learning experiences.
            </li>
            <li class="text-gray-500 my-2">With accessible fee structures and scholarship options, we ensure quality
                education is within reach for all deserving students.
            </li>
        </ul>
        <p class="my-2 text-gray-500 font-semibold">Join us on this exciting journey, and together, let's build a
            brighter, more sustainable future for the business world.</p>
    </div>
    <div id="specialization" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Business and Commerce Disciplines &
                Specializations</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">
                MBA with Specializations
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-center">
                <a href="schools/arni-school-of-business-management-and-commerce/finance"
                   class="block bg-white shadow-md border border-gray-200 hover:shadow-lg transition-shadow p-6 rounded-2xl hover:bg-blue-100">
                    Finance
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/marketing"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Marketing
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/human-resource"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Human Resource
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/business-analytics-and-data-science"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Business Analytics and Data Science
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/operation-and-supply-chain-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Operation and Supply Chain Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/product-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Product Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/international-business"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    International Business
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/digital-marketing"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Digital Marketing
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/brand-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Brand Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/fintech"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Fintech
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/event-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Event Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/media-and-entertainment-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Media and Entertainment Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/hospital-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Hospital Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/pharmaceutical-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Pharmaceutical Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/retail-management"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Retail Management
                </a>
                <a href="schools/arni-school-of-business-management-and-commerce/entrepreneurship"
                   class="block bg-white p-6 rounded-2xl hover:bg-blue-100 shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
                    Entrepreneurship
                </a>
            </div>
        </div>
    </div>

    <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
        <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
            <div>
                <p class="text-3xl font-bold">200+</p>
                <p class="text-lg">Programs</p>
            </div>
            <div>
                <p class="text-3xl font-bold">500+</p>
                <p class="text-lg">Faculties</p>
            </div>
            <div>
                <p class="text-3xl font-bold">11000+</p>
                <p class="text-lg">Students</p>
            </div>
            <div>
                <p class="text-3xl font-bold">120+</p>
                <p class="text-lg">Acre of campus</p>
            </div>
        </div>
    </div>

    <div class="w-full">
        <div id="hod-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img
                    src="assets/img/hods-as-per-schools/dr-irshad-ahmad-sofi-arni-school-of-business-management-and-commerce.png"
                    alt="HOD" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Irshad Ahmad Sofi
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">HOD’s Message</h2>
                <p class="text-gray-700 text-justify">
                    Greetings!!!!
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    It is my immense pleasure to welcome you all to the ARNI School of Business Management & Commerce at
                    ARNI University. I am delighted to have you on board at ARNI School of Business Management &
                    Commerce to explore numerous opportunities not only for academic excellence but for professional
                    growth.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    To accomplish your career goals, we provide several postgraduate, undergraduate, and diploma
                    programs in respective to business management and commerce. Students can pursue an MBA or BBA in
                    various specializations along with commerce subjects. With a team of industry experts and
                    professionals, we have frequently updated our curriculum to keep up with the latest industry trends,
                    business challenges, and economic shifts.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    I warmly invite you to be a part of our vibrant academic community, explore your potential, and
                    transform your aspirations into achievements.
                </p>
                <p class="text-gray-700 mt-2 text-justify">With best wishes,</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Dr. Irshad Ahmad Sofi</p>
                <p class="text-gray-700 mt-2 text-justify">HOD, ARNI School of Business Management & Commerce</p>
                <p class="text-gray-700 mt-2 text-justify">ARNI University</p>
            </div>

        </div>

    </div>

    <div id="whats-happening" class="w-full">
        <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
            <div class="container mx-auto px-6">
                <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                        <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                        <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                            <!-- <p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                            <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                            <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center mt-10">
                    <a
                        href="/whats-happening/event-calendar"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div id="expert-faculty" class="w-full">
        <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
            <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
            <div class="relative w-full max-w-6xl overflow-hidden">
                <div
                    class="flex transition-transform duration-300 ease-in-out"
                    [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                >
                    <div
                        *ngFor="let faculty of faculties"
                        class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                (click)="prev()"
                class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
            >
                <i class="fa fa-chevron-left text-[#012E26]"></i>
            </button>
            <button
                (click)="next()"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
            >
                <i class="fa fa-chevron-right text-[#012E26]"></i>
            </button>
            <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                    (click)="goTo('about/faculty')">
                View All Faculty
            </button>
        </div>
        <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
            <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
            <div class="w-full">
                <div
                    *ngFor="let faculty of faculties | slice:0:3"
                    class="flex flex-col items-center p-4"
                >
                    <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-[80%]">
                        <div class="h-[140px] flex items-center justify-center">
                            <img
                                [src]="faculty.image"
                                alt="faculty image"
                                class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                            />
                        </div>
                        <div class="h-[140px] flex flex-col items-center justify-center text-center">
                            <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                            <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-center">
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('about/faculty')">
                    View All Faculty
                </button>
            </div>
        </div>
    </div>

    <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
        <div class="container mx-auto px-4 text-center">
            <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
            <div class="testimonial-slider relative">
                <div class="overflow-hidden px-2">
                    <div
                        class="flex transition-transform duration-500 ease-in-out"
                        [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                    >
                        <ng-container *ngFor="let group of groupedTestimonials">
                            <div class="w-full flex-shrink-0 flex pb-4 justify-center">
                                <div
                                    *ngFor="let testimonial of group"
                                    class="w-full md:1/2 lg:w-1/3 px-3"
                                >
                                    <div
                                        class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                        <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                            <div
                                                class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                            >
                                                <div class="w-24 h-24 rounded-full bg-white p-1">
                                                    <img
                                                        [src]="testimonial.image"
                                                        [alt]="testimonial.name"
                                                        class="w-full h-full rounded-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pt-16 pb-8 px-6">
                                            <h3
                                                class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                            >
                                                {{ testimonial.name }}
                                            </h3>
                                            <div class="flex justify-center mb-4">
                                                <i
                                                    class="fa fa-star text-yellow-400"
                                                    *ngFor="let star of [1, 2, 3, 4, 5]"
                                                ></i>
                                            </div>
                                            <p class="text-gray-700 text-center mb-6">
                                                {{ testimonial.feedback }}
                                            </p>
                                            <div class="text-center text-sm text-gray-600">
                                                <p class="font-semibold">{{ testimonial.course }}</p>
                                                &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                            Placed In:
                                                            <span class="text-[#00BFA5]">
                              {{ testimonial.company }}
                            </span>
                                                        </p>&ndash;&gt;
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                &lt;!&ndash; Pagination Dots &ndash;&gt;
                <div class="flex justify-center mt-8 space-x-2">
                    <button
                        *ngFor="let group of groupedTestimonials; let i = index"
                        [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                        class="w-3 h-3 rounded-full transition-all duration-300"
                        (click)="setTestimonialSlide(i)"
                    ></button>
                </div>
            </div>

            <div class="flex justify-center mt-10">
                <a
                    href="/quick-links/student-testimonial"
                    class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                >
                    View More
                </a>
            </div>
        </div>
    </div>-->


    <div id="gallery">
        <div class="container-fluid mb-10">
            <div class="flex flex-col md:flex-row">
                <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                    <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                         class="w-full h-[500px] shadow-lg">
                </div>
                <div class="w-full md:w-2/5 md:pl-4">
                    <iframe class="w-full h-[500px] object-cover shadow-lg"
                            src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
    <div id="recruiters" class="w-full">
        <div class="bg-blue-100 text-center font-sans py-12">
            <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
            <div class="flex items-center justify-center gap-6 py-4">
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="prevSlide()">&#10094;
                </button>
                <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                    <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                         [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                        <div *ngFor="let recruiter of recruiters"
                             class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                            <img [src]="recruiter.logo" [alt]="recruiter.name"
                                 class="max-w-[80px] sm:max-w-[100px] h-auto">
                        </div>
                    </div>
                </div>
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="nextSlide()">&#10095;
                </button>
            </div>
            <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
        </div>
    </div>
</section>

